const defaultWidth = 20;
const defaultHeight = 20;
export const KTDSIcon = ({ width = defaultWidth, height = defaultHeight }: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M117.627 141.898L102.749 116C98.4378 108.498 98.4378 99.2654 102.749 91.7638L126.893 49.6529C131.219 42.1375 139.212 37.4937 147.862 37.4937H180L119.721 141.898C119.256 142.709 118.093 142.709 117.627 141.898Z"
        fill="#1D70FF"
      />
      <path
        d="M59.5799 141.898L44.7019 116C40.3904 108.498 40.3904 99.2654 44.7019 91.7638L68.8461 49.6529C73.1576 42.1375 81.1509 37.4937 89.8013 37.4937H119.845C120.775 37.4937 121.364 38.5104 120.885 39.321L61.6603 141.898C61.195 142.709 60.0316 142.709 59.5662 141.898H59.5799Z"
        fill="#1D70FF"
      />
      <path
        d="M0 37.5347L34.7108 57.5941C36.4491 58.597 37.3935 60.5892 37.065 62.5814L32.6303 89.744C32.4524 90.8706 30.9605 91.1454 30.3856 90.1562L0 37.5347Z"
        fill="#BBD4FF"
      />
      <path
        d="M0 37.5347L34.656 57.6765C36.3943 58.6932 38.5843 58.5146 40.1446 57.2369L61.3598 39.8017C62.2358 39.0735 61.7294 37.6446 60.5933 37.6446L0 37.5347Z"
        fill="#1D70FF"
      />
    </svg>
  );
};
KTDSIcon.displayName = 'KTDSIcon';
